import listActions from 'src/modules/workflow/list/workflowListActions';
import WorkflowService from 'src/modules/workflow/workflowService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'WORKFLOW_DESTROY';

const workflowDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowDestroyActions.DESTROY_STARTED,
      });

      await WorkflowService.destroyAll([id]);

      dispatch({
        type: workflowDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.workflow.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/workflow');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: workflowDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: workflowDestroyActions.DESTROY_ALL_STARTED,
      });

      await WorkflowService.destroyAll(ids);

      dispatch({
        type: workflowDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.workflow.destroyAll.success'),
      );

      getHistory().push('/workflow');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: workflowDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default workflowDestroyActions;
